import React, { useCallback, MouseEvent } from 'react';

import {
  TitleSmallText,
  H1Text,
  FontEmphasis,
} from '@prisjakt/ui/text/variants';
import Lazy from '@prisjakt/ui-lazy';
import { MediaButton } from 'src/components/media-button';

import * as S from './styles';

import { FacetLink } from './types';

type Props = {
  link: FacetLink;
  selected: boolean;
  onClickPreventDefault: boolean;
  lazyLoadImage?: boolean;
  Component: React.ComponentType<
    React.PropsWithChildren<React.PropsWithChildren<S.ListItemProps>>
  >;
  onClick?: (link: FacetLink) => void;
};

const NavigationLink = ({
  link,
  selected,
  onClickPreventDefault,
  Component,
  onClick,
  lazyLoadImage = true,
}: Props) => {
  const onClickHandler = useCallback(
    (e: MouseEvent) => {
      // Help google with a-links, but handle filter updates via actions
      if (onClick) {
        if (onClickPreventDefault) {
          e.preventDefault();
        }
        onClick(link);
      }
    },
    [link, onClick, onClickPreventDefault]
  );
  const image = link.imageUrl;

  return (
    <Component
      selected={selected}
      data-test="NavigationLink"
      data-cy={link.value}
    >
      <MediaButton
        media={
          <S.ListItemImage>
            {!image ? (
              <H1Text container="span" emphasis={FontEmphasis.LOW}>
                {link.value.replace(/[^\w]+/, '').charAt(0)}
              </H1Text>
            ) : (
              <>
                {typeof image === 'string' &&
                  (lazyLoadImage ? (
                    <Lazy offset={0}>
                      <img src={image} alt={link.value} />
                    </Lazy>
                  ) : (
                    <img src={image} alt={link.value} />
                  ))}
              </>
            )}
          </S.ListItemImage>
        }
        url={(link.indexable && link.path) || undefined}
        onClick={onClickHandler}
      >
        <S.ListItemText>
          <S.LimitedTextField>
            <TitleSmallText>{link.value}</TitleSmallText>
          </S.LimitedTextField>
        </S.ListItemText>
      </MediaButton>
    </Component>
  );
};

export default NavigationLink;
